import './App.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';

// ─── Suppress Firebase AbortError dev overlay ───
const isAbortError = (msg) =>
  typeof msg === 'string' &&
  (msg.includes('AbortError') ||
    msg.includes('aborted') ||
    msg.includes('signal is aborted'));

// Patch the error event the overlay listens to
const originalAddEventListener = window.addEventListener.bind(window);
window.addEventListener = (type, listener, options) => {
  if (type === 'error' || type === 'unhandledrejection') {
    const wrapped = (event) => {
      const msg =
        event?.reason?.message ||
        event?.reason?.name ||
        event?.message ||
        '';
      if (isAbortError(msg)) {
        event.preventDefault?.();
        event.stopImmediatePropagation?.();
        return;
      }
      listener(event);
    };
    return originalAddEventListener(type, wrapped, options);
  }
  return originalAddEventListener(type, listener, options);
};

window.addEventListener('unhandledrejection', (e) => {
  if (isAbortError(e?.reason?.message || e?.reason?.name || '')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

// ────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);